import { gql } from '@apollo/client';

const GET_TRANSLATE_IMPROVEMENTS_QUERY = gql`
  query getTranslateImprovements(
    $after: String = null
    $endDate: DateTime = null
    $first: Int = null
    $language: ECountry = null
    $projectId: String!
    $startDate: DateTime = null
    $status: ETranslateImprovementsStatus = null
  ) {
    translateImprovement {
      getTranslateImprovements: list(
        after: $after
        end: $endDate
        first: $first
        language: $language
        projectId: $projectId
        start: $startDate
        status: $status
      ) {
        totalCount
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
        items {
          url
          proposedText
          originalText
          language
          status
          id
        }
      }
    }
  }
`;

export { GET_TRANSLATE_IMPROVEMENTS_QUERY };
